import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../features/auth/authSlice";

/**
 * Redirect authenticated users away from auth pages
 * Used for login, signup, forgot password pages
 */
export default function RedirectIfAuthenticated({ children, to = "/" }) {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const location = useLocation();

  if (isAuthenticated) {
    const from = location.state?.from;
    const redirectTo = from
      ? `${from.pathname}${from.search ? from.search : ""}`
      : to;
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
